const React = require('react')

module.exports = { 
      attributes: {"nl":{"contact_cta":{"image_url":"/assets/eduard-avatar-bg-gray.jpeg","main_title":"Laten we het hebben over jouw volgende data-innovatie","check_items":["Vrijblijvend introductiegesprek","Voorstel voor een meeting binnen 12 uur"],"button_text":"Neem contact op"}},"en":{"contact_cta":{"image_url":"/assets/eduard-avatar-bg-gray.jpeg","main_title":"Let's talk about your next data innovation","check_items":["Free non-binding introductory conversation","Meeting proposal within 12 hours"],"button_text":"Get in touch"}}},
    
      react: 
      function (props) {
        Object.keys(props).forEach(function (key) {
          this[key] = props[key]
        })
        const markdown = /*#__PURE__*/React.createElement("div", {
  className: "frontmatter-markdown"
});
        return markdown
      }
    ,
     }